import { render, staticRenderFns } from "./GlobalProfile.vue?vue&type=template&id=8d2c86c8&scoped=true"
import script from "./GlobalProfile.vue?vue&type=script&lang=js"
export * from "./GlobalProfile.vue?vue&type=script&lang=js"
import style0 from "./GlobalProfile.vue?vue&type=style&index=0&id=8d2c86c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2c86c8",
  null
  
)

export default component.exports